import { ScopeBySector } from '../scopes-types';

export const SCOPES_FESTIVAL: ScopeBySector = {
  '': {},
  ANY: {},
  TEAM: {
    all: 'TEAM',
    mobility: 'TEAM-MOBILITY',
    catering: 'TEAM-CATERING',
    accommodation: 'TEAM-ACCOMMODATION',
  },
  ARTISTS: {
    all: 'ARTISTS',
    mobility: 'ARTISTS-MOBILITY',
    catering: 'ARTISTS-CATERING',
    accommodation: 'ARTISTS-ACCOMMODATION',
    cargo: 'ARTISTS-CARGO',
  },
  SITE: {
    all: 'SITE',
    'energy-water-waster': 'SITE-ENERGY-WATER-WASTE',
    'equipment-cargo': 'SITE-EQUIPMENT-CARGO',
    building: 'SITE-BUILDING',
  },
  PUBLIC: {
    catering: 'PUBLIC_SUPPLIER',
  },
};
